import { useSpring, animated } from '@react-spring/web';
import { useBarSpringConfig } from '../../../hooks/useBarSpringConfig.js';
import { jsx } from 'react/jsx-runtime';

function LabelWrapper({
  animationDelay,
  children,
  x
}) {
  const springConfig = useBarSpringConfig({
    animationDelay
  });
  const spring = useSpring({
    from: {
      transform: 'translateX(0px)',
      opacity: 0
    },
    to: {
      opacity: 1,
      transform: `translateX(${x}px)`
    },
    ...springConfig
  });
  return (
    /*#__PURE__*/
    // animating the foreignObject does not work on Safari,
    // so we need to use a g instead
    jsx(animated.g, {
      style: {
        opacity: spring.opacity,
        transform: spring.transform
      },
      children: children
    })
  );
}

export { LabelWrapper };
